import React from 'react';
import { connect } from "react-redux";
import PortletSpinner from '../../../partials/layout/PortletSpinner';
import { Portlet, PortletBody } from "../../../partials/content/Portlet";
import * as projectsDuck from '../../../store/ducks/projects.duck';
import * as companiesDuck from '../../../store/ducks/companies.duck';
import DataGridBase from '../../../partials/layout/DataGridBase';
import { injectIntl } from "react-intl";
import { withRouter } from '../../../shared/hoc/withRouter';
import { GetAccessRights } from "../../../router/Protector/Protector";
import * as projectsCrud from '../../../crud/projects.crud';
import { listAccountsAllowedRegisterBatchOperations } from '../../../router/Protector/AccessExceptions';

class Projects extends React.Component {
  constructor(props) {
    super(props);
    this.canCreateNew = GetAccessRights("/admin/projects/new-project", this.props.userProfile).allowAccess;

    this.batchOperationsEnabled = false;
    if (process.env.REACT_APP_BATCH_OPERATIONS_ENABLED === "true") {
        //REGISTER SUPPORTS BATCH OPERATION
        if (listAccountsAllowedRegisterBatchOperations.includes(this.props.userProfile.accounttype)) {
            this.batchOperationsEnabled = true;
        }
    }
  }

  getFormConfig = () => {
    const formFields = [
        {
            caption: this.props.intl.formatMessage({ id: 'PROJECT.FIELD.NAME' }),
            dataField: 'name',
            required: true,
            dataType: 'string'
        }
    ];

    formFields.push({
        caption: this.props.intl.formatMessage({ id: 'PROJECT.FIELD.COMPANY' }),
        dataField: 'companyid',
        required: true,
        dataType: 'list',
        options: {
            dataSource: this.props.companies,
            valueExpr: 'companyid',
            displayExpr: 'name'
        }
    });

    formFields.push({
        caption: this.props.intl.formatMessage({ id: 'PROJECT.FIELD.TYPE' }),
        dataField: 'projecttype',
        required: false,
        dataType: 'string'
    });

    formFields.push({
        caption: this.props.intl.formatMessage({ id: 'PROJECT.FIELD.CODE' }),
        dataField: 'projectcode',
        required: true,
        dataType: 'string'
    });

    return formFields;
  }

  componentDidMount() {
    this.props.loadProjects();
    this.props.loadCompanies();
  }

  onTableSelectionChanged = ({ selectedRowsData }) => {
    if (selectedRowsData.length > 0) {
      const data = selectedRowsData[0];
      this.props.navigate(`/admin/projects/${data.projectid}/overview`);
    }
  }
  calculateProjectState = (rowData) => {
    if (rowData.deleted === 1) {
      return this.props.intl.formatMessage({ id: 'OPTIONS.STATUS.DELETED' });
    }
    else {
      switch (rowData.recordstatus) {
        case 1:
          return this.props.intl.formatMessage({ id: 'OPTIONS.STATUS.ACTIVE' });
        case 2:
          return this.props.intl.formatMessage({ id: 'OPTIONS.STATUS.COMPLETED' });
        case 3:
          return this.props.intl.formatMessage({ id: 'OPTIONS.STATUS.ARCHIVED' });
        default:
          return 'Unknown';
      }
    }
  }
  render() {
    if (!this.props.projects || !this.props.companies) {
      return (<PortletSpinner />);
    }

    return (
      <Portlet>
        <PortletBody>
          <DataGridBase
            version="2"
            //BATCH OPS
            batchOperations={this.batchOperationsEnabled}
            batchFormFields={this.getFormConfig()}
            batchImportEndpoint={projectsCrud.importProjects}
            onBatchRecordsUpdated={this.props.loadProjects}
            customFields={this.props.customFields}
            //BATCH OPS
            title={this.props.intl.formatMessage({ id: "PROJECT.LIST.TITLE" })}
            createPath={this.canCreateNew ? "/admin/projects/new-project" : null}
            name={`Projects`}
            dataSource={this.props.projects}
            keyExpr="projectid"
            onSelectionChanged={this.onTableSelectionChanged}
            hoverStateEnabled={true}
            rowAlternationEnabled={false}
            columns={[
              { caption: this.props.intl.formatMessage({ id: "PROJECT.FIELD.PROJECT.ID" }), dataField: "projectid" },
              { caption: this.props.intl.formatMessage({ id: "PROJECT.FIELD.COMPANY" }), dataField: "company" },
              { caption: this.props.intl.formatMessage({ id: "PROJECT.FIELD.NAME" }), dataField: "name" },
              { caption: "State", dataField: "recordstatus", calculateCellValue: this.calculateProjectState },
              { caption: this.props.intl.formatMessage({ id: "PROJECT.FIELD.TYPE" }), dataField: "projecttype" },
              { caption: this.props.intl.formatMessage({ id: "PROJECT.FIELD.COUNTRY" }), dataField: "country" },
              { caption: this.props.intl.formatMessage({ id: "PROJECT.FIELD.CODE" }), dataField: "projectcode" },
            ]}
          />
        </PortletBody>
      </Portlet>
    );
  }
}

const mapStateToProps = store => ({
  projects: store.projects.projects,
  userProfile: store.auth.userProfile,
  companies: store.companies.companies
});

const mapDispatchToProps = {
  loadProjects: projectsDuck.actions.fetchStart,
  loadCompanies: companiesDuck.actions.fetchStart
}

export default withRouter(injectIntl(connect(mapStateToProps, mapDispatchToProps)(Projects)));
